import React from "react";

const DEFAULT_CLASSES = {
  container:
    "pa2 shadow-0 hairline-1 ba br2 flex flex-column justify-between color-text--primary",
  content: "w-100 flex flex-row justify-between items-center",
  title: "f5 fw6 color-primary",
  body: "f6 pt2",
  footer: "f7 pt2",
  callout: "flex flex-row items-center flex color-primary fw6"
};

const Percentage = ({ value }) => {
  const val = value.split("%")[0];
  return (
    <div className="f5">
      {val}
      <span className="f7">%</span>
    </div>
  );
};

const PERCENTAGE = "percentage";

const FORMAT_NODE = {
  [PERCENTAGE]: Percentage
};

const Callout = ({ title, body, footer, callout, customClasses }) => {
  const classes = { ...DEFAULT_CLASSES, ...customClasses };
  let calloutNode;
  if (callout) {
    const FormatNode = FORMAT_NODE[callout.format];
    if (FormatNode) {
      calloutNode = <FormatNode {...callout} />;
    } else {
      calloutNode = callout.value;
    }
  }

  return (
    <div className={classes.container}>
      <div className={classes.content}>
        <div className={classes.title}>{title}</div>
        <div className={classes.callout}>{calloutNode}</div>
      </div>
      {body && <div className={classes.body}>{body}</div>}
      {footer && <div className={classes.footer}>{footer}</div>}
    </div>
  );
};

export default Callout;
